/**
 * 全局第三方代码区域
 * */
document.addEventListener('DOMContentLoaded', function() {
  // impact 跨站点追踪的需求
  try {
    const imRef = new URLSearchParams(window.location.search).get('im_ref');
    if (!imRef) return;

    function processGlobalMenu() {
      const widget = document.querySelector('hs-global-menu-widget');
      if (!widget || !widget.shadowRoot) return false;

      const links = widget.shadowRoot.querySelectorAll('.link');
      links.forEach(link => {
        const url = new URL(link.href);
        if (!url.searchParams.has('im_ref')) {
          url.searchParams.set('im_ref', imRef);
          link.href = url.toString();
        }
      });
      return true;
    }

    if (!processGlobalMenu()) {
      const observer = new MutationObserver(() => {
        if (processGlobalMenu()) observer.disconnect();
      });
      observer.observe(document.body, { childList: true, subtree: true });
      setTimeout(() => observer.disconnect(), 3000);
    }
  } catch (err) {
    // 捕获异常，防止整个脚本崩溃
    console.error('Global Menu Script Error:', err);
  }
});
